interface Suggestion {
  title: string;
  value: string;
}

interface SuggestionsListProps {
  filteredSuggestions: Suggestion[];
  activeSuggestion: number;
  onClick: (suggestion: Suggestion) => void;
}

const SuggestionsList: React.FC<SuggestionsListProps> = ({ filteredSuggestions, activeSuggestion, onClick }) => {
  return  (
    <ul className="polymer-normal-login-ul" style={{ border: "1px solid #0C8188", borderBottomLeftRadius: '8px', borderBottomRightRadius: '8px', borderTopWidth: '0', listStyleType: 'none', margin: '0', maxHeight: '300px', overflowY: 'auto', paddingLeft: '0', width: '100%' }}>
      {filteredSuggestions.map((suggestion, index) => {
        const style = { padding: '10px', cursor: 'pointer', backgroundColor: activeSuggestion === index ? '#eff8fa' : 'white'};
        return (
          <li
            style={style}
            key={`${index}-${suggestion.value}`}
            onClick={() => {
               onClick(suggestion)
            }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#eff8fa'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
            className="polymer-normal-login-li"
          >
            {suggestion.title}
          </li>
        );
      })}
    </ul>
  )
}

export default SuggestionsList;
